// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"183":"d119c5f0","364":"5ea59d8c","495":"41e716e6","694":"3c94deb1"}[chunkId] + ".chunk.js";
};